import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(links)/candidatesAI/[token]/redirect-client.tsx");
